import { AxiosResponse } from 'axios';
import { sortSymtomsByClassifications } from 'helpers/pet.helpers';
import { authHeader } from 'services';

import { Api } from './api/axios.service';

const IMAGE_URL = `${process.env.REACT_APP_BASE_API_URL}/api/pet/image-download`;

const inQueueLength = () =>
  Api.get('treatment-queue/length-in-queue', {
    headers: authHeader(),
  });

  const getNextPet = () =>
  Api.get(`treatment-queue/treatment/find-next`, {
    headers: authHeader(),
  });

const startAppointment = (treatmentQueueId: string) =>
  // FIXME: Pass treatment queue id to backend
  Api.get(`treatment-queue/treat/${treatmentQueueId}`, {
    headers: authHeader(),
  });

const setAppointmentOnHold = () =>
  Api.get('treatment-queue/pop', {
    headers: authHeader(),
  });

/**
 * Get appointment information from vet
 *
 * @return {*}  {Promise<void>}
 */
const getAppointmentInfo = async (): Promise<any> => {
  try {
    const headers = authHeader();

    const { data } = await Api.get('treatment-queue/vet', {
      headers,
    });

    /* Get complete pet image with authentication */
    if (data.pet.image) {
      data.pet.imageUrl = `${IMAGE_URL}/${data.pet._id}/?access_token=${headers.Authorization}`;
    }

    data.symptoms = sortSymtomsByClassifications(data.symptoms);

    return data;
  } catch (reason: any) {
    const { message } = reason as Error;

    throw new Error(message || 'Não foi possível obter os dados do pet');
  }
};

const getTreatmentOnGoing = () =>
  Api.get('treatment-on-going', {
    headers: authHeader(),
  });

const deleteTreatment = (pet: string) =>
  Api.delete(`treatment-on-going/${pet}`, {
    headers: authHeader(),
  });

const saveHistory = (pet: string, data: any) =>
  Api.post(`treatment-history?pet=${pet}`, data, {
    headers: authHeader(),
  });

const changeStatus = () =>
  Api.get(`treatment-queue/change-status`, {
    headers: authHeader(),
  });

const sendReport = (callId: string, report: string) =>
  Api.post(
    `call/report/${callId}`,
    { report },
    {
      headers: authHeader(),
    }
  );

interface IFinishTreatmentOnGoing {
  treatmentId: string;
  annotations: string;
  roomId: string;
}
/**
 * Finish Treatment by vet
 *
 * @param {IFinishTreatmentOnGoing} data
 * @return {*}  {Promise<AxiosResponse<any>>}
 */
const finishTreatmentOnGoing = (
  data: IFinishTreatmentOnGoing
): Promise<AxiosResponse<any>> =>
  Api.put('/treatment-on-going/finish-treatment-on-going-vet', data, {
    headers: authHeader(),
  });

const updateTreatmentAnotation = (data: any): Promise<AxiosResponse<any>> =>
  Api.put(
    `/treatment-on-going/update-annotations/${data.treatmentId}`,
    { annotations: data.annotations },
    {
      headers: authHeader(),
    }
  );

export const AppointmentService = {
  inQueueLength,
  startAppointment,
  getAppointmentInfo,
  getTreatmentOnGoing,
  deleteTreatment,
  saveHistory,
  changeStatus,
  setAppointmentOnHold,
  sendReport,
  finishTreatmentOnGoing,
  updateTreatmentAnotation,
  getNextPet,
};
